import { render } from "./Jail.vue?vue&type=template&id=086e0fde"
import script from "./Jail.vue?vue&type=script&lang=js"
export * from "./Jail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__